import { render, staticRenderFns } from "./OrderSummaryFooter.vue?vue&type=template&id=23d4da94&scoped=true&"
import script from "./OrderSummaryFooter.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryFooter.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryFooter.vue?vue&type=style&index=0&id=23d4da94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d4da94",
  null
  
)

export default component.exports